import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type BulkUpdateEmployeesWorkflowState = {
  bulkUpdateWorkflowId: string | null;
  bulkUpdateEmployeesCount: number;
};

const BULK_UPDATE_EMPLOYEES_WORKFLOW_STORAGE_KEY =
  'bulkUpdateEmployeesWorkflowId';
const BULK_UPDATE_EMPLOYEES_COUNT_STORAGE_KEY = 'bulkUpdateEmployeesCount';

const getInitialState = (): BulkUpdateEmployeesWorkflowState => {
  let storedWorkflowId: string | null = null;
  let storedCount: string | null = null;

  try {
    storedWorkflowId = localStorage.getItem(
      BULK_UPDATE_EMPLOYEES_WORKFLOW_STORAGE_KEY
    );
    storedCount = localStorage.getItem(BULK_UPDATE_EMPLOYEES_COUNT_STORAGE_KEY);
  } catch {
    // localStorage is unavailable at module-init time in some environments
    // (e.g. jsdom before setup, SSR). Slice initialises with empty state.
  }

  return {
    bulkUpdateWorkflowId: storedWorkflowId,
    bulkUpdateEmployeesCount: storedCount ? parseInt(storedCount, 10) : 0,
  };
};

const initialState: BulkUpdateEmployeesWorkflowState = getInitialState();

const temporalWorkflowsSlice = createSlice({
  name: 'temporalWorkflows',
  initialState,
  reducers: {
    setBulkUpdateEmployeesWorkflow: (
      state,
      action: PayloadAction<{
        workflowId: string;
        employeesCount: number;
      }>
    ) => {
      state.bulkUpdateWorkflowId = action.payload.workflowId;
      state.bulkUpdateEmployeesCount = action.payload.employeesCount;

      localStorage.setItem(
        BULK_UPDATE_EMPLOYEES_WORKFLOW_STORAGE_KEY,
        action.payload.workflowId
      );
      localStorage.setItem(
        BULK_UPDATE_EMPLOYEES_COUNT_STORAGE_KEY,
        action.payload.employeesCount.toString()
      );
    },
    clearBulkUpdateEmployeesWorkflow: state => {
      state.bulkUpdateWorkflowId = null;
      state.bulkUpdateEmployeesCount = 0;

      localStorage.removeItem(BULK_UPDATE_EMPLOYEES_WORKFLOW_STORAGE_KEY);
      localStorage.removeItem(BULK_UPDATE_EMPLOYEES_COUNT_STORAGE_KEY);
    },
  },
});

export const {
  setBulkUpdateEmployeesWorkflow,
  clearBulkUpdateEmployeesWorkflow,
} = temporalWorkflowsSlice.actions;

export default temporalWorkflowsSlice;
